import React from "react";
import { ProductStructList } from "../structs/ProductStructList";
import { ProductStruct } from "../structs/ProductStruct";
import Paper from "@mui/material/Paper";
import { BASE_URL_API, PRODUCT_BASE_URL_API } from "../Const";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

export class ProductComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            productList: [],
        };
    }

    componentDidMount() {
        let url = BASE_URL_API + "product?market_id=" + this.props.market_id;
        if (this.props.category_id !== -1) {
            url += "&category_id=" + this.props.category_id;
        }

        fetch(url, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("pwa_token"),
                "Content-Type": "application/json",
            },
        })
            .then((response) => response.json())
            .then((results) => {
                const data = new ProductStructList();

                results.data.forEach((item) => {
                    if (!item.category) return;

                    let group = data.productList.find(
                        (p) => p.category === item.category.title
                    );

                    if (!group) {
                        group = new ProductStruct();
                        group.category = item.category.title;
                        data.productList.push(group);
                    }

                    group.productList.push(item);
                });

                /* ------------- تغییر اصلی: مرتب‌سازی --------------- */
                data.productList.forEach((group) => {
                    group.productList.sort((a, b) => {
                        const aHasPic = a.pictures && a.pictures.length > 0;
                        const bHasPic = b.pictures && b.pictures.length > 0;

                        if (aHasPic === bHasPic) return 0;   // هر دو یا هیچ‌کدام عکس ندارند
                        return aHasPic ? -1 : 1;             // اگر A عکس دارد جلو بیاید
                    });
                });
                /* --------------------------------------------------- */

                this.setState({ productList: data.productList });
            })
            .catch((error) => {
                console.log("error loading products", error);
            });
    }

    renderProductCard = (product) => {
        const MAX_LENGTH = 20;

        return (
            <Link
                key={product.id}
                to={`/product?id=${product.id}`}
                style={{
                    width: 150,
                    flexShrink: 0,
                    textAlign: "right",
                    textDecoration: "none",
                    color: "inherit",
                }}
            >
                <Paper
                    style={{
                        width: "100%",
                        height: 140,
                        backgroundImage: `url(${
                            product.pictures && product.pictures.length > 0
                                ? PRODUCT_BASE_URL_API + product.pictures[0].url
                                : "hamekara-logo.png"
                        })`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        borderRadius: 8,
                    }}
                />
                <div
                    style={{
                        fontSize: 14,
                        marginTop: 8,
                        color: "#000",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                >
                    <strong>
                        {product.title.length > MAX_LENGTH
                            ? product.title.substring(0, MAX_LENGTH) + "..."
                            : product.title}
                    </strong>
                </div>

                {product.del_price > 0 ? (
                    <>
                        <div
                            style={{
                                fontSize: 12,
                                color: "gray",
                                textDecoration: "line-through",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {`${product.price
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")} تومان`}
                        </div>
                        <div
                            style={{
                                fontSize: 14,
                                color: "green",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {`${(product.price - product.del_price)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")} تومان`}
                        </div>
                    </>
                ) : (
                    <div
                        style={{
                            fontSize: 14,
                            color: "green",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }}
                    >
                        {product.price > 0
                            ? `${product.price
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")} تومان`
                            : "تماس بگیرید."}
                    </div>
                )}
            </Link>
        );
    };

    render() {
        const containerStyle = {
            display: "flex",
            flexDirection: "row",
            overflowX: "auto",
            overflowY: "hidden",
            padding: "16px 8px",
            background: "transparent",
            direction: "rtl",
            gap: 12,
        };

        return this.state.productList.map((group, i) => (
            <Box key={i} style={{ marginBottom: 32 }}>
                <Grid
                    container
                    alignItems="center"
                    style={{ padding: "0 8px", direction: "rtl" }}
                >
                    <Grid item xs={8} sm={10} md={10} lg={11}>
                        <strong style={{ fontSize: 16 }}>{group.category}</strong>
                    </Grid>
                    <Grid item xs={4} sm={2} md={2} lg={1} style={{ textAlign: "left" }}>
                        <a
                            style={{ color: "gray", fontSize: 14 }}
                            href={`/product-list/?market_id=${this.props.market_id}&category_id=${group.productList[0].category.id}`}
                        >
                            مشاهده همه &gt;
                        </a>
                    </Grid>
                </Grid>

                <div style={containerStyle}>
                    {group.productList.map((product) =>
                        this.renderProductCard(product)
                    )}
                </div>
            </Box>
        ));
    }
}
